import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { InterfaceService } from '@app/interfaces';
import { SettingsService } from '@app/core';

@Injectable({
    providedIn: 'root'
})
export class AdminService extends InterfaceService {

    constructor(
        private http: HttpClient,
    ) {
        super();
    }

    getAllVehicleTrackerDevices(): Observable<any> {
        let url = 'vehicletrackers';

        return this.http.get(this.getApiUrl(url));
    }

    getClientsBasicDetails(clientId: any): Observable<any> {
        let url = 'clients/' + clientId + '/basicdetails';

        return this.http.get(this.getApiUrl(url));
    }

    getLineItemPriceAccordingToQuantityRange(id: any, quantity: any): Observable<any> {
        let url = 'vehicletrackers/' + id + '/quantity/' + quantity + '/cost';

        return this.http.get(this.getApiUrl(url));
    } 

    getVehicleTrackerPrice(id: any, quantity: any) {
    const url = `vehicle_tracker/${id}/price?quantity=${quantity}`;
    return this.http.get(this.getApiUrl(url));
    }

    purchaseTrackerCheckoutSession(requestPayload: any): Observable<any> {
        const formData: FormData = new FormData();
        let url = 'vehicle_tracker/checkout_session';

        requestPayload.trackers.forEach((tracker: any, index: number) => {
            Object.keys(tracker).forEach((key: string) => {
                formData.append(`trackers[${index}][${key}]`, String(tracker[key]));
            });
        });

        // Append shippingAddress if present
        if (requestPayload.shippingAddress) {
            Object.keys(requestPayload.shippingAddress).forEach((key: string) => {
                if (requestPayload.shippingAddress[key] !== undefined && requestPayload.shippingAddress[key] !== null) {
                    formData.append(`shippingAddress[${key}]`, String(requestPayload.shippingAddress[key]));
                }
            });
        }

        return this.http.post(this.getApiUrl(url), formData);
    }

    getSuccessPayment(reference:any){
        let url = `checkout_session/success?reference=${reference}`;
        return this.http.get(this.getApiUrl(url));
    }

    getCanceledPayment(reference: any) {
        const url = `checkout_session/cancel?reference=${reference}`;
        return this.http.put(this.getApiUrl(url), {});
    }

    getCheckoutSessionPayment(): Observable<any> {
        let url = 'checkout_session_for_subscription';
        return this.http.get(this.getApiUrl(url));
    }

    getCheckoutSessionPaymentInvoice(): Observable<any> {
        let url = 'checkout_session_for_payment_required';
        return this.http.get(this.getApiUrl(url));
    }

    getSummaryDetails(): Observable<any> {
        let url = 'view_clients_license_summary';
        return this.http.get(this.getApiUrl(url));
    }

    getClientInvoices(clientId: any,searchInvoiceId?: string,page?: number,pageSize?: number,isNewAdmin?: boolean,filters?: any[]): Observable<any> {
        const url = `clients/${clientId}/invoices`;
        // Build query params
        let httpParams = new HttpParams();
        if (searchInvoiceId) httpParams = httpParams.set('invoiceid', searchInvoiceId);
        if (page !== undefined) httpParams = httpParams.set('page', page.toString());
        if (pageSize !== undefined) httpParams = httpParams.set('limit', pageSize.toString());

        if (isNewAdmin) {
            // Use POST with filters in body
            const body: any = {};
            if (filters && filters.length > 0) {
                body.filters = filters;
            }
            return this.http.post(this.getApiUrl(url), body, { params: httpParams });
        } else {
            // Use GET for old admin
            return this.http.get(this.getApiUrl(url), { params: httpParams });
        }
    }


    downloadInvoice(invoiceId: string | number): Observable<Blob> {
        const url = `download_invoice/${invoiceId}`;
        return this.http.get(this.getApiUrl(url), { responseType: 'blob' });
    }

    getClientsPaymentdetail(type): Observable<any> {
        let url = `clients_payment_details/${type}`;
        return this.http.get(this.getApiUrl(url));
    }

    getFilterInvoice(): Observable<any> {
        let url = 'clients_invoice_filters';
        return this.http.get(this.getApiUrl(url));
    }

    getdownloadContract(): Observable<any> {
        let url = 'getContractPdfDownloadLink';
        return this.http.get(this.getApiUrl(url));
    }

    getStripePublicKey(): Observable<any> {
        let url = 'getStripePublicKey';

        return this.http.get(this.getApiUrl(url));
    }

    cancelPurchaseTrackerOrder(transactionUUID: any): Observable<any> {
        let url = 'cancelPurchaseTrackerOrder?transactionUUID=' + transactionUUID;

        return this.http.delete(this.getApiUrl(url));
    }

    getDeleteCard(){
        let url = 'get_deleted_stripe_account';
        return this.http.get(this.getApiUrl(url));
    }

    getInvoiceDetail(){
        let url = 'payment_required_invoices';
        return this.http.get(this.getApiUrl(url));
    }

    getVehicleTrackerHistory(params: { page: number; limit: number }) {
    const url = 'vehicle_tracker/order/history';

        return this.http.get(this.getApiUrl(url), {
            params: {
            page: params.page.toString(),
            limit: params.limit.toString()
            }
        });
    }

    getVehicleTrackerList(){
        let url = 'vehicle_tracker';
        return this.http.get(this.getApiUrl(url));
    }

    addSmartDebit(payload) {
        const url = 'add_smart_debit';
        const body = payload;
        return this.http.put(this.getApiUrl(url), body);
    }

    directDebitDetail(){
        let url = 'direct_debit_details';
        return this.http.get(this.getApiUrl(url));
    }

    clientsPaymentMethod(){
        let url = 'clients_payment_method_settings';
        return this.http.get(this.getApiUrl(url));
    }

    contractViewStatus() {
        const url = 'update_contract_view';
        return this.http.put(this.getApiUrl(url), {});
    }

    // Inside your component or service
    transformSummaryDetails(originalSummaryDetails: any): any {
        const {
            licenceDetails: originalLicenceDetails,
            monthly,
            yearly,
            currency,
            billingFrequency,
            ...extraFields
        } = originalSummaryDetails;

        const transformedSummaryDetails: any = {
            licenceDetails: [],
            monthly,
            yearly,
            currency,
            billingFrequency,
            ...extraFields
        };

        if (Array.isArray(originalLicenceDetails)) {
            originalLicenceDetails.forEach(function (licence: any) {
                const discountDetails = licence.discountDetails;

                if (Array.isArray(discountDetails) && discountDetails.length > 0) {
                    discountDetails.forEach(function (discount: any) {
                        transformedSummaryDetails.licenceDetails.push({
                            productLicenceName: licence.productLicenceName,
                            pricingPlansName: licence.pricingPlansName,
                            licenceTypesName: licence.licenceTypesName,
                            numberOfCl: discount.numberOfCl ? discount.numberOfCl : licence.numberOfCl,
                            licencePrice: licence.licencePrice,
                            discountPrice: discount.discountPrice ? discount.discountPrice : null,
                            total: discount.total ? discount.total : licence.total,
                            discountDetails: {
                                numberOfCl: discount.numberOfCl  ? discount.numberOfCl : licence.numberOfCl,
                                basePrice: discount.basePrice ? discount.basePrice : licence.licencePrice,
                                discountPrice: discount.discountPrice ? discount.discountPrice : null,
                                total: discount.total ? discount.total : licence.total,
                                monthlyDiscount: discount.monthlyDiscount || [],
                                userRange: discount.userRange || []
                            },
                            basePrice: discount.basePrice ? discount.basePrice : licence.licencePrice
                        });
                    });
                } else {
                    // Single or no discount
                    transformedSummaryDetails.licenceDetails.push({
                        productLicenceName: licence.productLicenceName,
                        pricingPlansName: licence.pricingPlansName,
                        licenceTypesName: licence.licenceTypesName,
                        numberOfCl: licence.numberOfCl,
                        licencePrice: licence.licencePrice,
                        discountPrice: licence.discountPrice ? licence.discountPrice : null,
                        total: licence.total,
                        discountDetails: {
                            numberOfCl: licence.numberOfCl,
                            basePrice: licence.licencePrice,
                            discountPrice: licence.discountPrice ? licence.discountPrice : null,
                            total: licence.total,
                            monthlyDiscount: [],
                            userRange: []
                        },
                        basePrice: licence.licencePrice
                    });
                }
            });
        }

        return transformedSummaryDetails;
    }

    hideTopBar() {
        const topBar = document.querySelector('.top_bar_wrapper') as HTMLElement;
        const container = document.querySelector('.app-container') as HTMLElement;
        if (topBar) {
            topBar.style.display = 'none';
            container.style.overflowY = 'hidden';
        }
    }

    downloadContract(contractId: any): Observable<Blob> {
        const url = `download_contract/${contractId}`;
        return this.http.get(this.getApiUrl(url), { responseType: 'blob' });
    }
}